import React from 'react';

import { EndOfDayFormColumnContainer } from '../../../containers/shipping-end-of-day-form-column-container';
import { messages } from '../messages';

export const EndOfDayForm = {
  getMessageDescriptor: () => messages.endOfDayForm,
  id: 'end-of-day-form',

  render: (data) => {
    return <EndOfDayFormColumnContainer fulfillmentId={data.id} />;
  },
};
